import { Eye, EyeSlash } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { usePrivacyStore } from '@/store/privacy/store';

export default function PrivacyToggle() {
  const { t } = useTranslation();
  const isDataVisible = usePrivacyStore((state) => state.isDataVisible);
  const toggleDataVisibility = usePrivacyStore((state) => state.toggleDataVisibility);

  return (
    <button
      onClick={toggleDataVisibility}
      className="topbar-btn privacy-toggle"
      style={{ border: 'none' }}
      aria-label={t('common.toggle_data_visibility')}
      title={isDataVisible ? t('common.hide_data') : t('common.show_data')}
    >
      {isDataVisible ? <Eye size={20} weight="bold" /> : <EyeSlash size={20} weight="bold" />}
    </button>
  );
}
